import React from "react";
import { Callout } from "@blueprintjs/core";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { Trans, withTranslation } from "react-i18next";

import Title from "../../Structure/logo";
import { authenticatedGetFetch, authenticatedPostFetch, getBackendRoute } from "../../../utils/AuthenticatedFetch";
import { ALPRSensor } from "./ALPRSensor";
import { ALPRServer } from "./ALPRServer";
import { ReconciliationsALPR } from "./Reconciliations"


class ALPRDashBoard extends React.Component {
  constructor() {
    super();
    this.state = {
      sensors: {}
    }

    this.updateServers = () => {
      authenticatedGetFetch('/alpr/servers?filtered=true',
        (response) => {
          this.setState({
            servers: response
          });
        });
    }
  }

  componentDidMount() {
    authenticatedGetFetch('/alpr/sensors/rt',
      (response) => {
        this.setState({
          sensors: response
        });
        this.client = new W3CWebSocket(getBackendRoute("WS") + "/supervision/alpr?images=true", ["Bearer", localStorage.getItem('token')]);
        this.client.onmessage = (message) => {
          const tmp = this.state.sensors;
          try {
            const data = JSON.parse(message.data);
            tmp[data.definition.ip] = data;
            this.setState({ sensors: tmp });
          } catch (e) {
            if (message.isTrusted === undefined)
              console.error("Error while parsing " + JSON.stringify(message));
          }
        };
      });

    this.updateServers();
  }

  componentWillUnmount() {
    if (this.client !== undefined)
      this.client.close();
  }

  render() {
    const servers = [];
    const sensors = [];
    for (const serverId in this.state.servers)
      servers.push(<ALPRServer
        {...this.state.servers[serverId]}
        onClouplingModeChange={(mode) => {
          authenticatedPostFetch('/alpr/couplingmode',
            { server: this.state.servers[serverId].ip, mode: mode },
            (status) => {
              console.log(status)
              if (status === 204)
                this.updateServers();
            });

        }}
        key={this.state.servers[serverId].ip}
      />);

    for (const sensorId in this.state.sensors)
      sensors.push(<ALPRSensor key={this.state.sensors[sensorId].definition.ip} {...this.state.sensors[sensorId]} />);

    return (
      <div>
        <div className="component-body">
          <Title icon="mobile-video" text="alpr management" />
          <div >
            <ReconciliationsALPR />
            <Callout title={<Trans>survision servers</Trans>}>{servers}</Callout>
            <Callout title={<Trans>ALPR sensors</Trans>}>{sensors}</Callout>
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(ALPRDashBoard);
